import BreadcrumbsComponent from './breadcrumbs-component';

/***
 * Handles the page breadcrumbs at the top of a page. Takes in two possible parameters:
 *
 * crumbs               a list of objects that each have parameters for "state" and "displayName"
 * currentPageName      the name to use for the current page
 */
const breadcrumbs = angular
    .module('FacilityData.Common.Breadcrumbs', [])
    .component('breadcrumbs', BreadcrumbsComponent)
    .name;

export default breadcrumbs;


// WEBPACK FOOTER //
// ./app/common/breadcrumbs/breadcrumbs.js